import { z } from "zod";
export const RoleSchema = z.object({
    id: z.string(),
    name: z.string(),
});
export const CharacterRoleSchema = z.object({
    label: z.string().optional(),
    roles: z.array(RoleSchema),
});
//# sourceMappingURL=index.js.map